<template>
  <div v-if="this.courseDetails">
    <div class="flex flex-wrap mb-6"  v-if="!['self_based'].includes(this.courseDetails.course_class_type)">
      <p style="min-width: 225px;" class="pr-2">Payments Managed Offline</p>
      <vs-switch v-model="payment_offline" />
    </div>
    <div class="flex flex-wrap mb-6"  v-if="!['self_based'].includes(this.courseDetails.course_class_type)">
      <p style="min-width: 225px;" class="pr-2">
        Invoices & Receipts Managed Offline
      </p>
      <vs-switch v-model="invoice_offline" />
    </div>
    <div class="flex flex-wrap">
      <div class="lg:w-1/2 w-full p-2" v-if="!['self_based'].includes(courseDetails.course_class_type)">
        <div style="background: #E6F5F6; border-radius: 8px;" class="p-4" v-if="!payment_offline">
          <p class="font-semibold mb-4">Payment Details</p>
          <vs-tabs>
            <vs-tab label="Credit Card">
                <div class="flex flex-wrap">
                    <div class="xl:w-1/2 w-full p-2">
                        <!-- <div class="payment_card_holder saved_card_holder">
                            <p>****  4213</p>
                            <svg width="58" height="18" viewBox="0 0 58 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M41.8606 1.02785C40.5435 0.54791 39.1513 0.307075 37.7495 0.316683C33.2161 0.316683 30.0145 2.60035 29.9918 5.87851C29.9635 8.28685 32.267 9.64401 34.0095 10.4487C35.7973 11.276 36.3951 11.7973 36.3895 12.5368C36.3781 13.6617 34.9615 14.1717 33.644 14.1717C31.8335 14.1717 30.8446 13.9195 29.3231 13.2877L28.7593 13.0242L28.1161 16.7982C29.2183 17.2572 31.2045 17.651 33.2558 17.685C38.0753 17.685 41.226 15.4155 41.2628 11.9277C41.3025 10.0038 40.0558 8.55035 37.4321 7.34901C35.837 6.56985 34.8481 6.04852 34.8481 5.25802C34.8481 4.55818 35.6953 3.81018 37.4661 3.81018C38.6447 3.78167 39.8159 4.00279 40.903 4.45902L41.328 4.64885L41.9711 1.00235L41.8606 1.02785ZM53.6246 0.622682H50.083C48.9808 0.622682 48.1506 0.925849 47.669 2.01952L40.8576 17.4499H45.6771L46.6405 14.9197L52.5225 14.9253C52.6613 15.5175 53.0863 17.4499 53.0863 17.4499H57.3363L53.6246 0.622682ZM23.4723 0.481015H28.0651L25.1921 17.3167H20.605L23.4723 0.475349V0.481015ZM11.8131 9.76018L12.2891 12.0977L16.7771 0.622682H21.642L14.4141 17.4272H9.56063L5.59397 3.19818C5.52972 2.96356 5.37884 2.76205 5.1718 2.63435C3.7421 1.89581 2.22724 1.33534 0.661133 0.965514L0.723466 0.611347H8.11563C9.11863 0.651014 9.92613 0.965514 10.1953 2.03651L11.8103 9.76868V9.76018H11.8131ZM47.958 11.4772L49.7883 6.76818C49.7656 6.81918 50.1651 5.79635 50.3975 5.16452L50.712 6.61802L51.7745 11.4743H47.9551V11.4772H47.958Z" fill="#4D487C"/>
                            </svg>
                        </div> -->
                        <div class="payment_card_holder new_card_holder" @click="addNewCard = true">
                            <div class="inline-flex items-center">
                                <span class="material-icons-outlined">add_circle</span>
                                <span>Add New</span>
                            </div>
                            <svg class="tick" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_3348_247784)">
                                <path d="M18.0002 6.99984L16.5902 5.58984L10.2502 11.9298L11.6602 13.3398L18.0002 6.99984ZM22.2402 5.58984L11.6602 16.1698L7.48016 11.9998L6.07016 13.4098L11.6602 18.9998L23.6602 6.99984L22.2402 5.58984ZM0.410156 13.4098L6.00016 18.9998L7.41016 17.5898L1.83016 11.9998L0.410156 13.4098Z" fill="#6A5432"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_3348_247784">
                                <rect width="24" height="24" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                    <div class="xl:w-1/2 w-full p-2">
                        <div v-if="addNewCard">
                            <vs-input label="Credit Card" placeholder="Enter card number" class="transparent_input_holder w-full mb-2" />
                            <vs-input label="Name" placeholder="Enter card name" class="transparent_input_holder w-full mb-2" />
                            <vs-row>
                                <vs-col vs-lg="8" vs-sm="12" class="p-1">
                                    <div class="flatpickr_with_icon mb-2">
                                        <label class="vs-input--label">Expiration Date</label>
                                        <flat-pickr
                                            class="w-full"
                                            placeholder="Start Date"
                                        />
                                    </div>
                                </vs-col>
                                <vs-col vs-lg="4" vs-sm="12" class="p-1">
                                    <vs-input label="CVV" placeholder="Enter CVV" class="transparent_input_holder mb-2 w-full" />
                                </vs-col>
                            </vs-row>

                            <vs-checkbox>Save Card</vs-checkbox>

                            <div class="my-4">
                                <vs-button class="mr-1">Confirm</vs-button>
                                <vs-button type="border" color="danger" @click="addNewCard = false">Cancel</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vs-tab>
            <vs-tab label="Paypal">
                Coming Soon
            </vs-tab>
            <vs-tab label="Other">
                Coming Soon
            </vs-tab>
          </vs-tabs>
        </div>

        <div v-if="payment_offline">
            <p class="font-semibold mb-4">Payment Method</p>
            <div style="background: #E6F5F6; border-radius: 8px;" class="p-4">
                <div class="mb-4">
                    <vs-radio v-model="offline_payment_radio" vs-value="cash">Cash</vs-radio>
                </div>
                <div class="mb-4">
                    <vs-radio v-model="offline_payment_radio" vs-value="bank">Bank Transfer</vs-radio>
                </div>
                <div class="mb-4">
                    <vs-radio v-model="offline_payment_radio" vs-value="cheque">Cheque</vs-radio>
                </div>
                <div class="mb-4">
                    <vs-radio v-model="offline_payment_radio" vs-value="card">Credit/ Debit Card</vs-radio>
                </div>
                <div class="mb-4">
                    <vs-radio v-model="offline_payment_radio" vs-value="direct">Direct Debit</vs-radio>
                </div>
                <div class="mb-4">
                    <vs-radio v-model="offline_payment_radio" vs-value="other">Other</vs-radio>
                </div>

                <div>
                    <label class="vs-input--label">Comment</label>
                    <vs-textarea placeholder="Enter Comment" class="w-full"></vs-textarea>
                </div>
            </div>
        </div>
      </div>
      <div v-if="['self_based'].includes(courseDetails.course_class_type)">
        <img v-if="Object.keys(courseDetails.courseImage).length > 0"
              :src="courseDetails.courseImage.file_path"
              width="500" height="500"
            />
            <img
              v-else
              width="500" height="500"
              src="https://scoolio-files.s3.ap-south-1.amazonaws.com/Scoolio/Students+watching+webinar+on+computer.jpg"
              alt="course_image"
            />
      </div>

      <div class="lg:w-1/2 w-full p-2">
        <p class="font-semibold mb-4">Enrollment Summary</p>
        <vs-collapse class="enrollment_confirmation_collapse" accordion>
          <vs-collapse-item v-if="!['self_based'].includes(this.courseDetails.course_class_type)">
            <div slot="header">
              Your chosen schedule
            </div>
            <div>
              <div style="background: #CEEBED; border-radius: 8px 8px 0px 0px;" class="p-4">
                <p class="font-bold">Your all {{totalSession}} sessions</p>
              </div>
              <div class="cstm_vuexy_table table-responsible white_table">
                <table>
                  <tbody>
                    <tr v-for="(slot,index) in viewscheduleData" :key="index" :class="!slot.status?'dark_break_holder':''">
                     <td>{{slot.session}}</td>
                      <td>{{slot.day}}</td>
                      <td>{{slot.date}}</td>
                      <td v-if="slot.start_time">{{slot.start_time.slice(0,-3)}} - {{slot.end_time.slice(0,-3)}}</td>
                      <td style="width: 50px">
                        <vs-tooltip :text="slot.info" position ="top" v-if="slot.info!=null">
                          <span class="material-icons-outlined">info</span>
                        </vs-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </vs-collapse-item>

          <vs-collapse-item>
            <div slot="header">
              Your Course Details
            </div>
            <div>
              <div style="background: #CEEBED; border-radius: 8px 8px 0px 0px;" class="text-center p-4">
                <p class="font-bold">Course Name</p>
              </div>
              <div style="background: #fff; border-radius: 8px;" class="text-center p-4">
                <p class="font-bold">{{scheduleDetails.course_name}}</p>
              </div>
              <vs-card class="my-2" v-if="!['self_based'].includes(this.courseDetails.course_class_type)">
                <vs-row>
                  <vs-col vs-w="12" class="p-1">
                    <p>Teacher Name</p>
                    <strong>{{scheduleDetails.teacher}}</strong>
                  </vs-col>
                  <vs-col vs-lg="6" vs-sm="12" class="p-1">
                    <p>Day</p>
                    <strong>{{scheduleDetails.day}}</strong>
                  </vs-col>
                  <vs-col vs-lg="6" vs-sm="12" class="p-1">
                    <p>Time</p>
                    <strong>{{scheduleDetails.start_time.slice(0, -3)}} - {{scheduleDetails.end_time.slice(0, -3)}}</strong>
                  </vs-col>
                  <vs-col vs-lg="6" vs-sm="12" class="p-1">
                    <p>First Lesson Date</p>
                    <strong>{{scheduleDetails.first_session_date}}</strong>
                  </vs-col>
                  <vs-col vs-lg="6" vs-sm="12" class="p-1">
                    <p>Last Lesson Date</p>
                    <strong>{{scheduleDetails.last_session_date}}</strong>
                  </vs-col>
                </vs-row>
              </vs-card>
            </div>
          </vs-collapse-item>

          <vs-collapse-item  v-if="!['self_based'].includes(this.courseDetails.course_class_type)">
            <div slot="header">
              Payment Details
            </div>
            <div class="cstm_vuexy_table table-responsive">
                <table>
                    <tbody>
                        <tr style="background: #CEEBED; border-radius: 3px 3px 0px 0px;">
                            <td><strong>Course fees</strong></td>
                            <td style="width: 50px; text-align: center;"><strong>£100.00</strong></td>
                        </tr>
                        <tr style="background: #fff;">
                            <td>1st installment  09/06/2022</td>
                            <td style="width: 50px; text-align: center;">£40.00</td>
                        </tr>
                        <tr style="background: #fff;">
                            <td>2nd installment  09/07/2022</td>
                            <td style="width: 50px; text-align: center;">£30.00</td>
                        </tr>
                        <tr style="background: #fff;">
                            <td>3rd installment  09/08/2022</td>
                            <td style="width: 50px; text-align: center;">£30.00</td>
                        </tr>
                    </tbody>
                </table>
            </div>
          </vs-collapse-item>
        </vs-collapse>

        <div v-if="payment_offline || invoice_offline" style="background: #E6F5F6; border-radius: 8px;" class="flex flex-wrap items-center px-4 py-2 mb-2">
            <span class="material-icons-outlined">info</span>
            <div style="width: calc(100% - 24px);" class="text-center">
                <p v-if="payment_offline">Payments Managed Offline</p>
                <p v-if="invoice_offline">Invoices & Receipts Managed Offline</p>
            </div>
        </div>

        <div style="padding: 0 30px;" class="flex flex-wrap justify-between"  v-if="!['self_based'].includes(this.courseDetails.course_class_type)">
            <p>Total Amount to Pay now</p>
            <p class="font-bold">$40.00</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import {fetchConfirmDetails} from '@/api/enrollment.js'

export default {
  props: {
    viewscheduleData:{default:null},
    courseDetails:{default:null},
    confirmModalData:{default:{}},
    counter:0
  },
  watch: {
    counter () {
      this.fetchConfirmItem()
      if (!['self_based'].includes(this.courseDetails.course_class_type)) {
        if (Object.entries(this.viewscheduleData).length > 0) {
          Object.entries(this.viewscheduleData).forEach((ele, value) => {

            this.totalSession += ele[1].status ? 1 : 0
          })

        }

      }


    }

  },
  data () {
    return {
      payment_offline: false,
      invoice_offline: false,
      addNewCard: false,
      offline_payment_radio: 'cash',
      totalSession:0,
      scheduleDetails: null
    }
  },
  components: {
    flatPickr
  },
  methods: {
    async fetchConfirmItem () {
      console.log(this.confirmModalData)
      const { data } = await fetchConfirmDetails(localStorage.getItem('customer_id'), this.courseDetails.id, this.confirmModalData)
      this.scheduleDetails = data.data
    }
  }
}
</script>
